import { render } from "./Tab.ce.vue?vue&type=template&id=7c10ab34"
import script from "./Tab.ce.vue?vue&type=script&lang=js"
export * from "./Tab.ce.vue?vue&type=script&lang=js"

import _style_0 from "./Tab.ce.vue?vue&type=style&index=0&id=7c10ab34&inline&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__